import React from 'react';
import { motion } from 'framer-motion';
import { SUPPORT_PHONE } from '../config/contact';

const TermsPage = () => {
  return (
    <div className="min-h-screen pt-32 pb-20 px-6">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-12"
        >
          <h1 className="text-5xl font-bold mb-6">Terms of Service</h1>
          <p className="text-gray-500">Last updated: January 2025</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="prose prose-invert max-w-none"
        >
          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-400 leading-relaxed">
                By accessing and using the ClearWay Mobility website and purchasing our products, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these Terms of Service, please do not use our website or purchase our products.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">2. Product Description</h2>
              <p className="text-gray-400 leading-relaxed mb-4">
                ClearWay is a smart mobility stick designed to assist visually impaired and elderly users with:
              </p>
              <ul className="list-disc list-inside text-gray-400 space-y-2 ml-4">
                <li>Forward obstacle detection using advanced sensors</li>
                <li>Surface detection for identifying potholes and drops</li>
                <li>Apple Find My integration for location tracking</li>
                <li>Reliable power system without complex rechargeable batteries</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">3. Orders and Payment</h2>
              <p className="text-gray-400 leading-relaxed mb-4">
                All orders are subject to acceptance and availability. We accept payment through Razorpay, in the billing currency of your delivery destination — INR (Indian Rupees) for orders shipped within India, and AED (UAE Dirhams) for orders shipped to the United Arab Emirates. The currency you will be charged in is shown on the order summary before you pay. By placing an order, you authorize us to charge your payment method for the total amount including product price and shipping fees.
              </p>
              <p className="text-gray-400 leading-relaxed">
                International customers: your card may be issued in a different currency from the one you are billed in, in which case your bank may apply foreign exchange conversion charges. Import duties and taxes may apply depending on your destination country.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">4. Shipping</h2>
              <p className="text-gray-400 leading-relaxed mb-4">
                We currently ship to:
              </p>
              <ul className="list-disc list-inside text-gray-400 space-y-2 ml-4 mb-4">
                <li>India - Shipping fee: ₹999</li>
                <li>United Arab Emirates (UAE) - Shipping fee: ₹2,999</li>
              </ul>
              <p className="text-gray-400 leading-relaxed">
                Shipping times vary by location. You will receive tracking information once your order ships.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">5. Use of Product</h2>
              <p className="text-gray-400 leading-relaxed">
                ClearWay is an assistive device designed to enhance mobility. However, it is not a substitute for traditional mobility aids, professional guidance, or medical advice. Users should exercise appropriate caution and judgment when using the product.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">6. Warranty</h2>
              <p className="text-gray-400 leading-relaxed">
                Every ClearWay includes six months of warranty from delivery, covering manufacturing defects and component failure in normal use. Dust, moisture and water damage, physical damage, wrong chargers, unauthorised repair or modification, wear and tear, and loss or theft are not covered. Warranty beyond the six months is available on request and is approved by an advisor before payment can be set up. The full terms, including how to claim and who pays for shipping, are on the <a href="/warranty" className="text-blue-400 hover:underline">warranty page</a>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">7. Limitation of Liability</h2>
              <p className="text-gray-400 leading-relaxed">
                To the maximum extent permitted by law, Clearway Mobility LLP shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the product.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">8. Privacy</h2>
              <p className="text-gray-400 leading-relaxed">
                Your use of our website and products is also governed by our Privacy Policy. Please review our Privacy Policy to understand our practices.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">9. Changes to Terms</h2>
              <p className="text-gray-400 leading-relaxed">
                We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to the website. Your continued use of the website after changes constitutes acceptance of the modified terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">10. Contact Information</h2>
              <p className="text-gray-400 leading-relaxed">
                For questions about these Terms of Service, please contact us at support@clearway-mobility.com
                {' '}or call {SUPPORT_PHONE}
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsPage;